<template>
	<div>
		<h1>Nyomtatás</h1>
    <v-tabs
      v-model="aktivtab"
      color="primary"
      icons-and-text
    >
      <v-tab>Szobakártyák<v-icon>fa-bed</v-icon></v-tab>

      <v-tab-item>
        <v-data-table
          :headers="papirok.szobakartyak.fejlec"
          :items="adatok.szobak"
          sort-by="szobanev"
          show-group-by
          show-select
          v-model="papirok.szobakartyak.kivalasztottak"
          item-key="id"
        >
        </v-data-table>
				<v-btn @click="szobakartyaknyomtatasa"><v-icon>fa-print</v-icon>Nyomtatás</v-btn>
      </v-tab-item>
    </v-tabs>
		<template>
  		<v-snackbar
  		 v-model="snackbar.megnyit"
  		>
  		 {{ snackbar.szoveg }}
  		 <v-btn
  			 color="pink"
  			 text
  			 @click="snackbar.megnyit = false"
  		 >
  			 Bezár
  		 </v-btn>
  		</v-snackbar>
	</template>

	</div>
</template>

<script>
	import router from '../router';
	export default {
		data: function(){
			return {
        aktivtab: 0,
        snackbar: {
          megnyit: false,
          szoveg: ""
        },
        papirok: {
          szobakartyak: {
            kivalasztottak: [],
            fejlec: [
              {
                text: "Szoba",
                value: "szobanev",
                align: "center",
                sortable: true,
                filterable: true,
                groupable: false
              }
            ],
            papirmeret: {
              magassag: 297,
              szelesseg: 210
            },
            papirmargomeret: {
              felso: 0,
              jobb: 0,
              also: 0,
              bal: 0
            },
            kartyameret: {
              magassag: 148,
              szelesseg: 105
            },
            kartyamargomeret: {
              felso: 5,
              jobb: 5,
              also: 5,
              bal: 5
            },
            megjelenoadatok: {
              csoport: true,
              csoportvezeto: false,
              minosites: false
            }
          }
        },
        adatok: {}
      }
		},
		computed: {

		},
		watch: {

		},
		methods: {
      szobakartyaknyomtatasa: function() {
        var papir = this.papirok.szobakartyak;
        this.axios.post(this.$store.state.backendeleres+"nyomtatas/szobakartyak",{szobak: papir.kivalasztottak.map(sz => sz.id), papirmeret: papir.papirmeret, papirmargomeret: papir.papirmargomeret, kartyameret: papir.kartyameret, kartyamargomeret: papir.kartyamargomeret, megjelenoadatok: papir.megjelenoadatok})
                  .then((response) => {
											let blob = new Blob([response.data], {type: 'application/pdf'}),
											url = window.URL.createObjectURL(blob);
											windows.open(url)
                  })
      }
		},
		mounted(){
      this.axios.get(this.$store.state.backendeleres+"nyomtatas/")
                .then((response) => {
                  if(response.data.bejelentkezve==false) this.kijelentkezes();
                  if(response.data.ok) this.adatok=response.data.adatok;
                })
    }
	}
</script>
